import { render, staticRenderFns } from "./LinkedCompList.vue?vue&type=template&id=385edc0a&scoped=true&"
import script from "./LinkedCompList.vue?vue&type=script&lang=js&"
export * from "./LinkedCompList.vue?vue&type=script&lang=js&"
import style0 from "./LinkedCompList.vue?vue&type=style&index=0&id=385edc0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385edc0a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkedCompItem: require('/home/bitrix/frontend/components/compilations/LinkedCompItem.vue').default})
